import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { Link } from '@digdir/designsystemet-react';

import { useUser } from '../../../hooks/useUser';
import { camelCasify, MainScreenTab } from '../../../utils/navigation';
import { MenuItemSpan } from '../../building/menu/styledComponents';

import { StyledNavLink } from './styledComponents';

export interface TitleProps {
  tab: MainScreenTab;
}

export const SideMenuButton: FC<TitleProps> = ({ tab }) => {
  const { t } = useTranslation();
  const { user } = useUser();

  const buttonText = t(`mainScreen.tab.${camelCasify(tab)}`, {
    context: user?.type
  });

  return (
    <Link asChild>
      <StyledNavLink to={tab} aria-label={buttonText}>
        {({ isActive }) => <MenuItemSpan isActive={isActive}>{buttonText}</MenuItemSpan>}
      </StyledNavLink>
    </Link>
  );
};
